import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { AI_RISK_REPORT_PDF_KEEP_WITH_NEXT_ATTRIBUTES } from '../../data/constants'
import styles from './SectionHeading.module.scss'

export default function SectionHeading({ id = undefined, titleId, questionId = undefined, keepWithNext = false }) {
  const keepWithNextAttributes = keepWithNext ? AI_RISK_REPORT_PDF_KEEP_WITH_NEXT_ATTRIBUTES : {}

  return (
    <div className={styles.heading} id={id} {...keepWithNextAttributes}>
      <h2 className={styles.title}>
        <FormattedMessage id={titleId} />
      </h2>
      {questionId && (
        <div className={styles.question}>
          <FormattedMessage id={questionId} />
        </div>
      )}
    </div>
  )
}

SectionHeading.propTypes = {
  id: PropTypes.string,
  titleId: PropTypes.string.isRequired,
  questionId: PropTypes.string,
  keepWithNext: PropTypes.bool,
}
